import React from "react";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import moment from "moment";
import Header from "../../../../../../components/wizard/Header";
import Footer from "../../../../../../components/wizard/Footer/Footer";
import useAuth from "../../../../../../hooks/useAuth";
import useMutation from "../../../../../../hooks/useMutation";
import { UPDATE_INVENTORY_REQUEST_MUTATION } from "../../../../../../constants/graphql/mutations";
import { serverFormatSeconds } from "../../../../../../utils/dates";
import ActionsButton from "./ActionsButton";
import { getWO } from "../../../../utils";

export default function Details({ project, inventoryRequest }) {
  const navigate = useNavigate();
  const { company } = useAuth();
  const [updateInventoryRequest] = useMutation(UPDATE_INVENTORY_REQUEST_MUTATION);

  const nextStep = () => {
    if (!inventoryRequest.pickingStartTime) {
      const pickingStartTime = moment().format(serverFormatSeconds);
      updateInventoryRequest({
        variables: {
          id: inventoryRequest.id,
          input: {
            pickingStartTime,
          },
        },
      });
    }

    const params = new URLSearchParams(window.location.search);
    params.set("step", "items");
    navigate({ search: params.toString() });
  };

  const topInfo = getWO(inventoryRequest);
  const dateValue = inventoryRequest.deliveryDate || inventoryRequest.startDate || "";
  const formattedDate = dateValue ? moment(dateValue).format("MM/DD/YYYY") : "";
  const filterField2 = company?.settings?.filter_field2 || "Project";
  const dateLabel = inventoryRequest.deliveryDate
    ? "Delivery Date"
    : inventoryRequest.startDate
    ? "Start Date"
    : "Date";

  return (
    <>
      <Header title="Outbound Order Details" info={topInfo} />
      <Box
        p={2}
        minHeight={400}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box>
          <Grid container spacing={1.5}>
            <Grid size={12}>
              <TextField
                size="small"
                fullWidth
                disabled
                value={inventoryRequest.projectName || project.name || ""}
                label={`${filterField2} Name`}
              />
            </Grid>
            <Grid size={6}>
              <TextField size="small" fullWidth disabled value={formattedDate} label={dateLabel} />
            </Grid>
            <Grid size={6}>
              <TextField
                size="small"
                fullWidth
                disabled
                value={inventoryRequest?.user?.email || ""}
                label="Created By"
              />
            </Grid>
            <Grid size={12}>
              <TextField
                size="small"
                multiline
                fullWidth
                disabled
                value={inventoryRequest.comment || ""}
                label="Comments"
                minRows={4}
              />
            </Grid>
            {inventoryRequest.pickingNotes && (
              <Grid size={12}>
                <TextField
                  size="small"
                  multiline
                  fullWidth
                  disabled
                  value={inventoryRequest.pickingNotes}
                  label="Picking Notes"
                  minRows={2}
                />
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
      <Box mt={2}>
        <Footer
          step={0}
          steps={3}
          startTime={inventoryRequest?.pickingStartTime}
          completeTime={inventoryRequest?.pickingCompleteTime}
        >
          <ActionsButton onClick={nextStep} />
        </Footer>
      </Box>
    </>
  );
}
